export default {
  timeToExpired: 0,
  isExpired: false,
};
